import { useDispatch, useSelector } from 'react-redux';

import { trackOpenContactPartnerModal } from 'src/components/molecules/ContactPartnerModal/tracking/contactPartnerModalEvents';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from 'src/redux/contactPartner';
import { getOptionsCostRange } from 'src/redux/product/utils/getOptionsCostRange';
import {
  selectAccessibility,
  selectBasket,
  selectProduct,
  selectProductReviews,
  selectSuspended,
} from 'src/redux/selectors';

export const useStandardLayout = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: ReduxApplicationState) => state);
  const accessibility = selectAccessibility(state);
  const basket = selectBasket(state);
  const product = selectProduct(state);
  const reviews = selectProductReviews(state);
  const suspended = selectSuspended(state);
  const partnerName = product.partner.name;

  const openContactPartnerModal = () => {
    dispatch(actions.openContactPartnerModal());
    trackOpenContactPartnerModal(partnerName);
  };

  return {
    basketMutationError: Boolean(basket.error),
    openContactPartnerModal,
    optionsCostRange: getOptionsCostRange(product.options, product.price.currency),
    pageLiveRegionText: accessibility.statusMessage,
    partnerHref: `/partners/${product.partner.shortcode}`,
    product,
    promoCodeMessage: state.content.promoCodeMessage || null,
    reviews,
    suspended,
  };
};
